import axios from 'axios';
import { CheckDiskCount, CheckDiskStatus } from 'models/response';
import { trackPromise } from 'react-promise-tracker';

import { CINIDISKSERVICE } from '../utils/constants';

/**
 * This API gets disk count for the graph
 * @param {string} dateFrom
 * @param {string} dateTo
 * @return {Promise<AxiosResponse<CheckDiskCount[]>>}
 */
const checkDiskCount = (dateFrom: string, dateTo: string) =>
  trackPromise(
    axios.get<CheckDiskCount[]>(`${CINIDISKSERVICE}/checkDiskCount`, {
      params: { dateFrom: dateFrom, dateTo: dateTo },
    }),
    'module',
  );

/**
 * This API gets disk status
 * @return {Promise<AxiosResponse<CheckDiskStatus[]>>}
 */
const checkDiskStatus = () =>
  trackPromise(axios.get<CheckDiskStatus[]>(`${CINIDISKSERVICE}/checkDiskStatus`), 'module');

export default {
  checkDiskCount,
  checkDiskStatus,
};
